import { render, staticRenderFns } from "./CircularIcon.vue?vue&type=template&id=70d722c2&lang=pug"
import script from "./CircularIcon.vue?vue&type=script&lang=js"
export * from "./CircularIcon.vue?vue&type=script&lang=js"
import style0 from "./CircularIcon.vue?vue&type=style&index=0&id=70d722c2&prod&lang=scss&soped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports